// 首页 - 三大理由
export const reasonComList = [
    {
        maxTitle: "强大的研发团队",
        descList: ["传奇资深开发工程师护航", "零门槛加入996传奇引擎"],
    },
    {
        maxTitle: "数千传奇开发者信赖",
        descList: ["云游、耀光、神话等", "数千开发优选传奇开发引擎"],
    },
    {
        maxTitle: "7x12小时客服服务支持",
        descList: ["专属客服团队", "全天技术答疑", "全程服务保障"],
    },
];

// 首页 - 引擎功能介绍
export const engineDescList = [
    {
        maxTitle: "正版授权 三端互通",
        contentDesc:
            "正版授权引擎，支持iOS、Android、PC、H5、3D（即将上线）多平台开发，高效、稳定跨平台，数据三端互通。",
    },
    {
        maxTitle: "可视化开发 自由定制",
        contentDesc:
            "自由编辑游戏GUI界面、属性、游戏参数，自由定义游戏玩法，游戏任务、活动、地图、怪物等游戏机制等自由创造，轻松创造自己的传奇游戏。",
    },
    {
        maxTitle: "多套便捷开发工具支持",
        contentDesc:
            "提供多套工具协助开发者开发，方便开发者资源、脚本、数据库转换，不定时更新工具功能。",
    },
    {
        maxTitle: "强大的996M2反外挂系统",
        contentDesc:
            "云端智能反外挂，对抗移动应用暴力破解，在网络层、应用层、系统层提供全面安全防护，安全与兼容性并行，无感知安全防护，不影响游戏玩家体验。",
    },
    {
        maxTitle: "兼容其他传奇引擎 一键转换",
        contentDesc:
            "兼容其他传奇引擎，传奇脚本一键转换，助力传奇开发者快速开发。",
    },
    {
        maxTitle: "提供数套开区底版 持续更新",
        contentDesc:
            "为传奇开发者学习996传奇引擎提供内容支持，免费提供多套传奇开区底版，版本内容丰富，持续更新。",
    },
    {
        maxTitle: "996传奇盒子流量支持",
        contentDesc:
            "经审核合格版本上架盒子，助力传奇开发者游戏推广，目前已数千款996传奇引擎开发的产品已上架996传奇盒子。",
    },
    {
        maxTitle: "7x12小时客服团队支持",
        contentDesc:
            "7x12小时客服团队支持响应，全天技术答疑，24小时服务器稳定运行保障。",
    },
    {
        maxTitle: "全网CDN加速",
        contentDesc:
            "异地多机房服务集群，覆盖范围广，架构灵活、高并发，全程为传奇开发者保驾护航。",
    },
];

export const imgList = [
    {
        url:
            // "https://static.dhsf.xqhuyu.com/offical/static/img/jt/jt_1.png",
            "/static/img/jt/jt_1.png",
        name: "引擎 - 独占性授权书",
    },
    {
        url:
            // "https://static.dhsf.xqhuyu.com/offical/static/img/jt/jt_2.png",
            "/static/img/jt/jt_2.png",
        name: "传奇-独占性授权声明",
    },
    {
        url:
            // "https://static.dhsf.xqhuyu.com/offical/static/img/jt/jt_3.png",
            "/static/img/jt/jt_3.png",
        name: "传奇世界-独占性授权声明",
    },
    {
        url:
            // "https://static.dhsf.xqhuyu.com/offical/static/img/jt/jt_4.png",
            "/static/img/jt/jt_4.png",
        name: "传奇世界-声明",
    },
    {
        url:
            // "https://static.dhsf.xqhuyu.com/offical/static/img/jt/jt_5.png",
            "/static/img/jt/jt_5.png",
        name: "传奇-声明",
    },
    {
        url:
            // "https://static.dhsf.xqhuyu.com/offical/static/img/jt/jt_6.png",
            "/static/img/jt/jt_6.png",
        name: "著作权授权书-1",
    },
    {
        url:
            // "https://static.dhsf.xqhuyu.com/offical/static/img/jt/jt_7.png",
            "/static/img/jt/jt_7.png",
        name: "著作权授权书-2",
    },
    {
        url:
            // "https://static.dhsf.xqhuyu.com/offical/static/img/jt/jt_8.png",
            "/static/img/jt/jt_8.png",
        name: "网络文化经营许可证",
    },
    {
        url:
            // "https://static.dhsf.xqhuyu.com/offical/static/img/jt/jt_9.png",
            "/static/img/jt/jt_9.png",
        name: "营业执照",
    },
    {
        url:
            // "https://static.dhsf.xqhuyu.com/offical/static/img/jt/jt_10.png",
            "/static/img/jt/jt_10.png",
        name: "增值电信业务经营许可证",
    },
];

export const dataList = [
    {
        title: "996传奇引擎下载",
        list_one: {
            title: "游戏展示服【热血合击】下载",
            data: [
                {
                    title: "PC",
                    link: "/static/app/996yq_pc_2021_08_31.zip",
                    target: "_blank",
                    time: "2021/08/31 20:00",
                    version: "V1.0.1",
                    size: "88.6MB",
                    state: 1,
                },
                {
                    title: "Android",
                    link: "/static/app/996yq_az_2021_06_21.apk",
                    target: "_blank",
                    time: "2021/06/21 20:00",
                    version: "V1.0.1",
                    size: "87.3MB",
                    state: 1,
                },
            ],
        },
        list_two: {
            title: "引擎下载",
            data: [
                {
                    title: "引擎下载",
                    link: "/static/app/996M2_2021_11_30.rar",
                    target: "_blank",
                    time: "2021/11/30 20:00",
                    version: "V1.0.1",
                    size: "72.1MB",
                    state: 1,
                },
                {
                    title: "基础包下载",
                    link: "http://bbs.996m2.com/forum-48-1.html",
                    target: "_blank",
                    time: "2021/06/21 20:00",
                    version: "V1.0.1",
                    size: "62.8MB",
                    state: 2,
                },
            ],
        },
    },
    {
        title: "996传奇世界引擎下载",
        list_one: {
            title: "游戏展示服【传世群英】下载",
            data: [
                {
                    title: "PC",
                    link:
                        "https://996box-static.oss-cn-hangzhou.aliyuncs.com/csyq/PCClient/996WolClient.zip",
                    target: "_blank",
                    time: "2021/06/21 20:00",
                    version: "V1.0.1",
                    size: "62.8MB",
                    state: 3,
                },
                {
                    title: "Android",
                    link:
                        "https://996box-static.oss-cn-hangzhou.aliyuncs.com/csyq/App/996Game_11020955.apk",
                    target: "_blank",
                    time: "2021/06/21 20:00",
                    version: "V1.0.1",
                    size: "62.8MB",
                    state: 3,
                },
                {
                    title: "手游设计版",
                    link:
                        "https://996box-static.oss-cn-hangzhou.aliyuncs.com/csyq/App/996WooolMLite(20211102).rar",
                    target: "_blank",
                    time: "2021/06/21 20:00",
                    version: "V1.0.1",
                    size: "62.8MB",
                    state: 4,
                },
            ],
        },
        list_two: {
            title: "引擎下载",
            data: [
                {
                    title: "引擎下载",
                    link:
                        "https://996box-static.oss-cn-hangzhou.aliyuncs.com/csyq/Engine/996Engine20211102.zip",
                    target: "_blank",
                    time: "2021/06/21 20:00",
                    version: "V1.0.1",
                    size: "62.8MB",
                    state: 3,
                },
                {
                    title: "基础包下载",
                    link: "http://woool.996m2.com/forum.php?mod=forumdisplay&fid=40",
                    target: "_blank",
                    time: "2021/06/21 20:00",
                    version: "V1.0.1",
                    size: "62.8MB",
                    state: 3,
                },
                {
                    title: "MySql环境",
                    link:
                        "https://996box-static.oss-cn-hangzhou.aliyuncs.com/csyq/Engine/MysqlServer.zip",
                    target: "_blank",
                    time: "2021/06/21 20:00",
                    version: "V1.0.1",
                    size: "62.8MB",
                    state: 4,
                },
            ],
        },
    },
];

export const boxList = [
    {
        title: "PC",
        time: "2021/07/23  20:00",
        target: "_blank",
        size: "54.9MB",
        version: "V1.0.0.2",
        link:
            "https://static.dhsf.xqhuyu.com/box/box_app/2021/07/23/1627035210000_tBsmW.exe",
        state: 4,
    },
    {
        title: "Android",
        time: "2021/07/23  20:00",
        target: "_blank",
        size: "16.8MB",
        version: "V1.3.1",
        link:
            "https://static.dhsf.xqhuyu.com/box/box_app/2021/07/23/1627034488000_jiKRw.apk",
        state: 4,
    },
    {
        title: "IOS",
        time: "2021/07/27  20:00",
        target: "_blank",
        size: "97MB",
        version: "V1.0.8",
        link: "https://www.pgyer.com/nMJp",
        state: 4,
    },
];
